export default __webpack_public_path__ + "static/media/verify_device_error.18907466.png";